import { contratoDe } from '../core/dominio.js';
import { S } from '../core/estado.js';
import { esc, num } from '../core/formato.js';
import { ROLES, ROL_DESC, db } from '../data/db.js';

/* =====================================================================
   USUARIOS
   ===================================================================== */
export function vistaUsuarios(){
  const lista = db.usuarios;
  return `<div class="page-head">
    <div><div class="eyebrow">Administración</div><h1>Usuarios y permisos</h1>
      <p>Cuatro roles y, para operarios y encargados, los contratos concretos a los que pueden entrar. Así cada zona ve solo lo suyo.</p></div>
    <button class="btn btn-p" data-act="nuevo-usuario">Dar de alta usuario</button></div>
  <div class="card"><div class="tabla-wrap"><table>
    <thead><tr><th>Nombre</th><th>Correo</th><th>Rol</th><th>Contratos asignados</th><th class="num">Actividad</th><th>Estado</th><th></th></tr></thead>
    <tbody>${lista.map(u=>`<tr style="${u.activo?'':'opacity:.55'}">
      <td><b>${esc(u.nombre)}</b><div style="font-size:12px;color:var(--gris)">${esc(u.area)}</div></td>
      <td class="mono" style="font-size:12.5px">${esc(u.email)}</td>
      <td><span class="tag t-${u.rol}">${esc(ROLES[u.rol]||u.rol)}</span><div style="font-size:11px;color:var(--gris-claro);max-width:26ch;margin-top:3px">${esc(ROL_DESC[u.rol]||'')}</div></td>
      <td style="font-size:12.5px">${u.contratos==='todos'?'<span style="color:var(--gris)">Todos</span>'
        :(u.contratos.map(id=>`<div class="cod">${esc(contratoDe(id)?.expediente||'—')}</div>`).join('')||'<span style="color:var(--gris-claro)">Ninguno</span>')}</td>
      <td class="num">${db.imputaciones.filter(i=>i.usuario===u.id).length} imp.<div style="font-size:11px;color:var(--gris-claro)">${db.pedidos.filter(p=>p.solicitante===u.id).length} pedidos</div></td>
      <td>${u.activo?'<span class="tag t-activo"><span class="punto"></span>Activo</span>':'<span class="tag t-inactivo">Inactivo</span>'}</td>
      <td style="white-space:nowrap">
        <button class="btn btn-x" data-act="editar-usuario" data-id="${u.id}">Editar</button>
        ${u.id!==S.usuario.id?`<button class="btn btn-x" data-act="alternar-usuario" data-id="${u.id}">${u.activo?'Desactivar':'Reactivar'}</button>`:''}
      </td></tr>`).join('')}</tbody></table></div></div>
  <div class="aviso a-azul" style="margin-top:16px"><div class="txt"><b class="tit">Sobre las bajas</b>
    Un usuario nunca se borra: se desactiva. Así sus imputaciones y pedidos anteriores siguen teniendo autor y las certificaciones antiguas no pierden trazabilidad.</div></div>`;
}

